import Container from "@client/content/Containers/container";
import TableView from "@client/content/controls/TableView/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { formatMoneyDisplay } from "@client/lib/format";
import { Status } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import DetailModal from "./DetailModal/container";
import { type MemberVouchers } from "./types";

export type MapProps = RootContainerProps & {
  items: MemberVouchers.Voucher[];
  status: string;
};

export interface ActionProps {
  onItemClick: (item: MemberVouchers.Voucher) => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <Container {...getContainerProps(props)}>
      <TableView
        {...getRootContainerProps(props)}
        idKey="voucherCodeId"
        isLoading={props.status === Status.Loading}
        columns={[
          { key: "issueDate", name: i18n.issued, dataType: "dateTime", align: "left" },
          {
            key: "amount",
            name: i18n.amount,
            dataType: "number",
            data: (x) => formatMoneyDisplay(x.amount, x.currencyCode),
            align: "left"
          },
          { key: "expiryDate", name: i18n.expiry, dataType: "dateTime", align: "left" }
        ]}
        data={props.items}
        noDataText={i18n.infoNoVouchers}
        onRowClick={props.onItemClick}
        itemMenu={null}
      />

      <DetailModal id={props.id} />
    </Container>
  );
};
